import React from "react";
import EditIcon from "@mui/icons-material/Edit";

const EditButtonCell = (editFn) => (props) => {
  const { dataItem } = props;

  return (
    <td className={"command-cell"}>
      <EditIcon onClick={() => editFn(dataItem)} />
    </td>
  );
};

export default EditButtonCell;
